import localforage from 'localforage'

export const deficiencies = {
    namespaced: true,
    state: {
        list: [],
        activeItem: undefined,
        status: 'idle',
        activeGroup: '',
        cropsGroupItem: undefined
    },
    mutations: {
        SET_DEFICIENCIES_LIST(state, payload) {
            state.list = payload
        },
        SET_DEFICIENCIES_ITEM(state, payload) {
            state.activeItem = payload
        },
        RESET_DEFICIENCIES_ITEM(state) {
            state.activeItem = undefined
        },
        SET_STATUS(state, payload) {
            state.status = payload
        },
        SELECT_GROUP(state, payload) {
            state.activeGroup = payload
        },
        SELECT_GROUP_ITEM(state, payload) {
            state.cropsGroupItem = payload
        }

    },
    actions: {
        async fetchList({ commit }) {
            commit('SET_STATUS', 'loading')
            try {
                const response = await this.$api.get('api/deficiencies.json')
                commit('SET_DEFICIENCIES_LIST', response.data.data)
                commit('SELECT_GROUP', response.data.data[0])
            } catch (error) {
                throw Error(error)
            } finally {
                commit('SET_STATUS', 'idle')
            }
        },
        // deficiencies item
        async fetchItem({ commit }, id) {
            commit('SET_STATUS', 'loading')
            try {
                const response = await this.$api.get(`api/deficiencies/view/${id}`)
                commit('SET_DEFICIENCIES_ITEM', response.data.data)
                const group = await localforage.getItem('group')
                commit('SELECT_GROUP', group)
            } catch (error) {
                throw Error(error)
            } finally {
                commit('SET_STATUS', 'idle')
            }
        },
        async fetchCropGroups({ commit }, id) {
            commit('SET_STATUS', 'loading')
            try {
                const response = await this.$api.get('api/cropGroups')
                commit('SET_DEFICIENCIES_LIST', response.data.data)
                commit('SELECT_GROUP', response.data.data[0])
            } catch (error) {
                throw Error(error)
            } finally {
                commit('SET_STATUS', 'idle')
            }
        },
        async fetchCropGroupItem({ commit }, id) {
            commit('SET_STATUS', 'loading')
            try {
                const response = await this.$api.get(`api/cropGroups/view/${id}`)
                commit('SELECT_GROUP_ITEM', response.data.data)
            } catch (error) {
                throw Error(error)
            } finally {
                commit('SET_STATUS', 'idle')
            }
        },
        async resetItem({ commit }) {
            commit('RESET_DEFICIENCIES_ITEM')
        },
        async selectGroup({ commit }, payload) {
            commit('SELECT_GROUP', payload)
            await localforage.setItem('group', payload)
        }
    },
    getters: {
        list: state => state.list,
        activeItem: state => state.activeItem,
        status: state => state.status,
        group: state => state.activeGroup,
        groupItem: state => state.cropsGroupItem
    }
}
